module.exports = __webpack_public_path__ + "img/lose_lottery1_small.cac269bb.png";